class ProductCardSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.track = this.querySelector('[data-product-card-slider-track]');
    this.slides = [...this.querySelectorAll('[data-product-card-slider-slide]')];
    this.dots = [...this.querySelectorAll('[data-product-card-slider-dot]')];
    this.arrows = [...this.querySelectorAll('[data-product-card-slider-arrow]')];
    this.link = this.parentElement?.querySelector('.product-card-slider__click-layer');

    if (!this.track || this.slides.length < 2) return;

    this.isTouching = false;
    this.hasSwiped = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchStartScroll = 0;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    /* ---------------- MOBILE SWIPE ---------------- */

    this.track.addEventListener(
      'touchstart',
      (e) => {
        if (!isMobile()) return;

        this.isTouching = true;
        this.hasSwiped = false;

        this.touchStartX = e.touches[0].clientX;
        this.touchStartY = e.touches[0].clientY;
        this.touchStartScroll = this.track.scrollLeft;
      },
      { passive: true }
    );

    this.track.addEventListener(
      'touchmove',
      (e) => {
        if (!isMobile() || !this.isTouching) return;

        const touch = e.touches[0];

        const diffX = touch.clientX - this.touchStartX;
        const diffY = touch.clientY - this.touchStartY;

        // uniquement si le mouvement est horizontal
        if (Math.abs(diffX) > Math.abs(diffY)) {
          this.track.scrollLeft = this.touchStartScroll - diffX;

          if (Math.abs(diffX) > 8) {
            this.hasSwiped = true;
          }

          this.updateDots();
        }
      },
      { passive: true }
    );

    this.track.addEventListener('touchend', () => {
      if (!isMobile()) return;

      this.isTouching = false;

      setTimeout(() => {
        this.hasSwiped = false;
      }, 200);
    });

    /* ---------------- MOBILE CLICK ---------------- */

    this.track.addEventListener(
      'click',
      (e) => {
        if (!isMobile()) return;

        if (this.hasSwiped) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return;
        }

        if (this.link?.href) {
          window.location.href = this.link.href;
        }
      },
      true
    );

    /* ---------------- DOTS ---------------- */

    this.track.addEventListener(
      'scroll',
      () => {
        this.updateDots();
      },
      { passive: true }
    );

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goTo(index);
      });
    });

    /* ---------------- ARROWS DESKTOP ---------------- */

    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const current = this.getCurrentIndex();
        const direction = arrow.dataset.productCardSliderArrow;

        const next =
          direction === 'next'
            ? current + 1
            : current - 1;

        this.goTo(
          Math.max(
            0,
            Math.min(next, this.slides.length - 1)
          )
        );
      });
    });

    this.updateDots();
  }

  getCurrentIndex() {
    return Math.round(
      this.track.scrollLeft / this.track.clientWidth
    );
  }

  updateDots() {
    const index = this.getCurrentIndex();

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  goTo(index) {
    const slide = this.slides[index];

    if (!slide) return;

    this.track.scrollTo({
      left: slide.offsetLeft,
      behavior: 'smooth'
    });

    this.updateDots();
  }
}

if (!customElements.get('product-card-slider')) {
  customElements.define('product-card-slider', ProductCardSlider);
}